/**
 * VNConfig Feature Flags
 *
 * @link https://shift4.atlassian.net/wiki/spaces/venuenext/pages/1978892595
 */
export const VNCONFIGS_FEATURE_ENABLEMENT_KEYS = {
  CFD_COMM_STATES: 'CFD_COMM_STATES',
  KIOSK_ATTRACT_LOOP_IMAGE: 'KIOSK_ATTRACT_LOOP_IMAGE',
  RECEIPT_SETTINGS: 'RECEIPT_SETTINGS',
  UNIQUE_INVOICE_NUMBERS: 'UNIQUE_INVOICE_NUMBERS',
  SPLIT_TABS: 'SPLIT_TABS',
  KIOSK_OFFLINE: 'KIOSK_OFFLINE',
  DISABLE_CACHE_IMAGES: 'DISABLE_CACHE_IMAGES',
  DISABLE_TRANSFER_TABS: 'DISABLE_TRANSFER_TABS',
  DISABLE_PPI_SPLIT_OFFLINE: 'DISABLE_PPI_SPLIT_OFFLINE',
  DISABLE_DEFAULT_REQUEST_TIMEOUT: 'DISABLE_DEFAULT_REQUEST_TIMEOUT',
  KIOSK_ALCOHOL_LIMITS: 'KIOSK_ALCOHOL_LIMITS',
}
